/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { GetOverdueTasksSummaryQueryResponse, GetOverdueTasksSummaryPathParams, GetOverdueTasksSummaryQueryParams, GetOverdueTasksSummary400, GetOverdueTasksSummary401, GetOverdueTasksSummary403, GetOverdueTasksSummary404, GetOverdueTasksSummary409, GetOverdueTasksSummary500 } from "../../types/analyticsController/GetOverdueTasksSummary.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { getOverdueTasksSummary } from "../../client/analyticsController/getOverdueTasksSummary.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getOverdueTasksSummaryQueryKey = (organizationId: GetOverdueTasksSummaryPathParams["organizationId"] | undefined, params?: GetOverdueTasksSummaryQueryParams) => [{ url: '/api/organizations/:organizationId/analytics/overdue-tasks-summary', params: {organizationId:organizationId} }, ...(params ? [params] : [])] as const

export type GetOverdueTasksSummaryQueryKey = ReturnType<typeof getOverdueTasksSummaryQueryKey>

export function getOverdueTasksSummaryQueryOptions(organizationId: GetOverdueTasksSummaryPathParams["organizationId"] | undefined, params?: GetOverdueTasksSummaryQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = getOverdueTasksSummaryQueryKey(organizationId, params)
        return queryOptions<GetOverdueTasksSummaryQueryResponse, ResponseErrorConfig<GetOverdueTasksSummary400 | GetOverdueTasksSummary401 | GetOverdueTasksSummary403 | GetOverdueTasksSummary404 | GetOverdueTasksSummary409 | GetOverdueTasksSummary500>, GetOverdueTasksSummaryQueryResponse, typeof queryKey>({
         enabled: !!(organizationId),
         queryKey,
         queryFn: async ({ signal }) => {
            return getOverdueTasksSummary(organizationId!, params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Overdue task count, the oldest overdue task and the farms affected (optionally one farm via ?establishmentId; ?today= is the caller's calendar day)
 * {@link /api/organizations/:organizationId/analytics/overdue-tasks-summary}
 */
export function useGetOverdueTasksSummary<TData = GetOverdueTasksSummaryQueryResponse, TQueryData = GetOverdueTasksSummaryQueryResponse, TQueryKey extends QueryKey = GetOverdueTasksSummaryQueryKey>(organizationId: GetOverdueTasksSummaryPathParams["organizationId"] | undefined, params?: GetOverdueTasksSummaryQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<GetOverdueTasksSummaryQueryResponse, ResponseErrorConfig<GetOverdueTasksSummary400 | GetOverdueTasksSummary401 | GetOverdueTasksSummary403 | GetOverdueTasksSummary404 | GetOverdueTasksSummary409 | GetOverdueTasksSummary500>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? getOverdueTasksSummaryQueryKey(organizationId, params)
         

         const query = useQuery({
          ...getOverdueTasksSummaryQueryOptions(organizationId, params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<GetOverdueTasksSummary400 | GetOverdueTasksSummary401 | GetOverdueTasksSummary403 | GetOverdueTasksSummary404 | GetOverdueTasksSummary409 | GetOverdueTasksSummary500>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}